import { makeAutoObservable, runInAction } from "mobx";

import { IRootStore } from "@/app/model/rootStore";

import { editDialogService } from "../api/editDialogService";
import { IUpdateDialogTitleParams } from "../types";

interface IOptions {
  dialogId: string;
  title: string;
}

export class EditDialogStore {
  rootStore: IRootStore;

  isOpen = false;
  options: IOptions | null = null;

  constructor(rootStore: IRootStore) {
    makeAutoObservable(this);

    this.rootStore = rootStore;
  }

  open(options: IOptions) {
    this.isOpen = true;
    this.options = options;
  }

  close() {
    this.isOpen = false;
    setTimeout(() => {
      this.options = null;
    }, 500);
  }

  reset() {
    this.isOpen = false;
    this.options = null;
  }

  async updateDialogTitle(params: IUpdateDialogTitleParams) {
    const response = await editDialogService.updateDialogTitle(params);

    runInAction(() => {
      this.rootStore.dialogsStore.dialogs.forEach((dialog) => {
        if (dialog.dialog_id === response.dialog_id) {
          dialog.title = response.title;
        }
      });
    });
  }
}
